module.exports = __webpack_public_path__ + "static/media/bodymap.752f2feb.svg";